import { render, staticRenderFns } from "./GetLoanPage.vue?vue&type=template&id=343c6c12&scoped=true"
import script from "./GetLoanPage.vue?vue&type=script&lang=ts"
export * from "./GetLoanPage.vue?vue&type=script&lang=ts"
import style0 from "./GetLoanPage.vue?vue&type=style&index=0&id=343c6c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c6c12",
  null
  
)

export default component.exports